export default __webpack_public_path__ + "static/media/Duration.8f3b3eb2.svg";